import apiClient from './client';

export const archiveAPI = {
  getAll: () => apiClient.get('/admin/archived'),
  archive: (entity, id) => apiClient.post(`/${entity}/${id}/archive`),
  unarchive: (entity, id) => apiClient.post(`/${entity}/${id}/unarchive`),
  archiveCascade: (entity, id) => apiClient.post(`/${entity}/${id}/archive?confirm_cascade=true`),
};
